import BaseCommand from "@/models/api/commands/BaseCommand";

export class CommentChangeCommand extends BaseCommand {
  CommandName = "CommentChange";
  Command: string;
  constructor(sessionId: string, operationId: string, comment: string) {
    super(sessionId, operationId);
    this.Command = comment;
  }
}
